export default function About() {
  return (
    <div className="min-h-screen bg-[#000000] px-6 py-12 md:px-20">
      <h2 className="text-3xl font-bold text-white mb-6 text-center">
        About Me
      </h2>

      <p className="text-lg text-white mb-6 leading-relaxed">
        I'm <strong>Arisrada Dhanabalan</strong>, a passionate and
        growth-oriented Full-Stack Developer with 1 year of professional
        experience. I specialize in building scalable web and mobile
        applications using the <strong>MERN stack</strong> and{" "}
        <strong>React Native (Expo)</strong>. My journey in development started
        with curiosity and grew into a commitment to writing clean, efficient
        code and crafting excellent user experiences.
      </p>

      <p className="text-lg text-white mb-6 leading-relaxed">
        At Enervoir Power Systems, I took full ownership of multiple frontend
        projects—both web and mobile—collaborated with cross-functional teams,
        and proactively upskilled in technologies like Next.js and backend
        development with Node.js and PostgreSQL.
      </p>

      <h3 className="text-2xl font-semibold text-white mt-8 mb-4">
        Technical Skills
      </h3>
      <div className="text-white">
        <ul className="list-disc list-inside">
          <li className="flex flex-row items-center w-full mb-2">
            <p className="font-semibold text-font-18 w-28 ">Frontend:</p>
            <p>
              HTML, CSS, JavaScript, Bootstrap, Tailwind CSS, React.js, Next.js,
              Material UI, jQuery, Responsive Design
            </p>
          </li>
          <li className="flex flex-row items-center w-full mb-2">
            <p className="font-semibold text-font-18 w-28 ">Mobile:</p>
            <p>React Native, Expo</p>
          </li>
          <li className="flex flex-row items-center w-full mb-2">
            <p className="font-semibold text-font-18 w-28 ">Backend:</p>
            <p>Node.js, Express.js, GraphQL</p>
          </li>
          <li className="flex flex-row items-center w-full mb-2">
            <p className="font-semibold text-font-18 w-28 ">Database:</p>
            <p>MongoDB, SQL, PostgreSQL</p>
          </li>
          <li className="flex flex-row items-center w-full mb-2">
            <p className="font-semibold text-font-18 w-28 ">Tools:</p>
            <p>Git, Bitbucket</p>
          </li>
        </ul>
      </div>
    </div>
  );
}
